import { EntityListSkuInputData } from '../entityListTypes';
import { EntityListSpecification } from './EntityListSpecification';
import { ProjectAdministrationSubpage } from '../../../projectAdministrationLib';
import { SkuEntityListContentStructure } from '../content_structure/SkuEntityListContentStructure';
import { EntityListSkuItemConverter } from '../converters/EntityListSkuItemConverter';
import { EntityListSkuItemValidator } from '../validators/EntityListSkuItemValidator';
import { ImportFormatItem } from '../../../../../lib/imports/importTypes';
import { SkuInputFormatProvider } from '../input_formats/SkuInputFormatProvider';
import { EntityListItemType, EntityListTypeName } from '@ydistri/api-sdk';

/**
 * Intermediary class for lists that contain SKUs.
 * This class sets the content structure, converter, and validator for SKU lists.
 * Specific classes should inherit from this class and pass subpage, pageTitle, title, and url in the constructor.
 */
export class SkuEntityListSpecification extends EntityListSpecification<EntityListSkuInputData> {
  public readonly itemType = EntityListItemType.Sku;

  // eslint-disable-next-line max-params -- wanted here
  constructor(
    subpage: ProjectAdministrationSubpage,
    pageTitle: string,
    title: string,
    menuOptionTitle: string,
    shortName: string,
    relatedEntityListTypes: EntityListTypeName[],
  ) {
    super(
      {
        subpage,
        pageTitle,
        title,
        menuOptionTitle,
        shortName,
        relatedEntityListTypes,
      },
      new SkuEntityListContentStructure(),
      new EntityListSkuItemConverter(),
      new EntityListSkuItemValidator(),
      new SkuInputFormatProvider(),
    );
  }

  getUniqueItemsForDuplicateCheck(): ImportFormatItem<EntityListSkuInputData>[] {
    return this.getInputFormat().filter(item => {
      return item.id === 'product' || item.id === 'store';
    });
  }
}
